<template>
  <div class="zchTabBar"></div>
</template>

<script>
export default {
  name: 'ZchTabBar',
}
</script>


<style lang="scss" scoped>
.zchTabBar {
  transition: all .4s;
  position: absolute;
  bottom: -2px;
  height: 2px;
  background-color: #409eff;
}
</style>